import { useSideMenuContext } from "contexts/SideMenuContext";
import { Heading, List } from "@chakra-ui/react";
import type { SideMenuProps } from "./SideMenu.d";
import SideMenuItem from "./SideMenuItem/SideMenuItem";

const SideMenu = ({ pageHeading }: SideMenuProps) => {
  const { headings, activeHeading } = useSideMenuContext();

  return (
    <>
      <Heading variant="h5" as="h5" mb={4} lineHeight="base">
        {pageHeading}
      </Heading>
      <List
        spacing={3}
        px={3}
        position="relative"
        ml="4px"
        _before={{
          content: `""`,
          position: "absolute",
          borderLeft: "1px",
          borderColor: "greyscale.400",
          top: "8px",
          left: "-1px",
          height: "calc(100% - 17px)",
        }}
      >
        {headings &&
          headings.map((heading) => (
            <SideMenuItem key={heading.current.id} heading={heading} isActive={heading === activeHeading} />
          ))}
      </List>
    </>
  );
};

export default SideMenu;
